import { render, staticRenderFns } from "./VUpload.vue?vue&type=template&id=32f4ec50&scoped=true"
import script from "./VUpload.vue?vue&type=script&lang=ts"
export * from "./VUpload.vue?vue&type=script&lang=ts"
import style0 from "./VUpload.vue?vue&type=style&index=0&id=32f4ec50&prod&lang=scss&scoped=true"
import style1 from "./VUpload.vue?vue&type=style&index=1&id=32f4ec50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4ec50",
  null
  
)

export default component.exports